import webAssemblyApplicationsIcon from '../../../public/svg/icons/rwdServices/webAssemblyApplications.svg';
import constEffectiveScalingIcon from '../../../public/svg/icons/whyRustForWeb/costEffectiveScaling.svg';
import fearlessConcurrencyIcon from '../../../public/svg/icons/whyRustForWeb/fearlessConcurrency.svg';
import memorySafetyWithoutTheRuntimeCostIcon from '../../../public/svg/icons/whyRustForWeb/memorySafetyWithoutTheRuntimeCost.svg';
import performanceThatActuallyMattersIcon from '../../../public/svg/icons/whyRustForWeb/performanceThatActuallyMatters.svg';

export const whyRustForWebData = [
  {
    title: 'Performance That Actually Matters',
    description:
      'Rust web applications run 3-10x faster than equivalent Node.js or Python services. For applications handling millions of requests per day, this translates to significant infrastructure cost savings.',
    img: performanceThatActuallyMattersIcon,
  },
  {
    title: 'Memory Safety Without the Runtime Cost',
    description: `Rust's ownership model eliminates entire categories of bugs at compile-time. No null pointer exceptions, no use-after-free errors, no data races in concurrent code. You get the memory safety of garbage-collected languages without the performance penalty.`,
    img: memorySafetyWithoutTheRuntimeCostIcon,
  },
  {
    title: 'Fearless Concurrency',
    description: `Building concurrent systems in Rust is actually enjoyable. The type system prevents data races at compile-time, so you can parallelize with confidence. Perfect for WebSocket servers, real-time applications, and high-throughput API services.`,
    img: fearlessConcurrencyIcon,
  },
  {
    title: 'WebAssembly Native',
    description: `Rust and WebAssembly were made for each other. Compile your Rust code to WASM and run computationally intensive tasks directly in the browser at near-native speeds. We\'ve built image processing tools, data visualization engines, and cryptographic systems that perform better than their JavaScript equivalents.`,
    img: webAssemblyApplicationsIcon,
  },
  {
    title: 'Cost-Effective Scaling',
    description:
      'Lower memory footprint and higher throughput mean you need fewer servers to handle the same load. Clients typically see 40-60% reduction in cloud computing costs after migrating performance-critical services to Rust.      ',
    img: constEffectiveScalingIcon,
  },
];
